module.exports = "./img/0f6bbf8877d1d61a64b29939348a2fbe.jpg";